module.exports = __webpack_public_path__ + "img/express.e02ad7b1.svg";